import './Button.scss'

export const Button = ({children, active, size, icon, type, variant, state, disabled, onClick, ...props}) => {
    return (
        <button
            className={'button'}
            data-variant={variant}
            data-state={state}
            data-icon={icon}
            data-size={size}
            data-active={active}
            type={type}
            onClick={onClick}
            disabled={disabled}
            {...props}
        >
            {state === 'loading' ?
                <span aria-hidden="true" className="material-symbols-outlined">progress_activity</span>
                : icon &&
                    <span aria-hidden="true" className={'material-symbols-outlined'}>{icon}</span>
            }
            <span className={'button-label'}>{children}</span>
        </button>
    )
}